/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponseItemsInnerPeriod } from './ListOperations200ResponseItemsInnerPeriod';
import {
    ListOperations200ResponseItemsInnerPeriodFromJSON,
    ListOperations200ResponseItemsInnerPeriodFromJSONTyped,
    ListOperations200ResponseItemsInnerPeriodToJSON,
    ListOperations200ResponseItemsInnerPeriodToJSONTyped,
} from './ListOperations200ResponseItemsInnerPeriod';

/**
 * 支払業務（operation）の基本情報
 * @export
 * @interface ListOperations200ResponseItemsInner
 */
export interface ListOperations200ResponseItemsInner {
    /**
     * 支払業務ID
     * @type {string}
     * @memberof ListOperations200ResponseItemsInner
     */
    id: string;
    /**
     * サービス名称
     * @type {string}
     * @memberof ListOperations200ResponseItemsInner
     */
    serviceName: string;
    /**
     * 支払金額
     * @type {number}
     * @memberof ListOperations200ResponseItemsInner
     */
    amount?: number;
    /**
     * サービス手数料
     * @type {number}
     * @memberof ListOperations200ResponseItemsInner
     */
    serviceFee?: number;
    /**
     * 支払総額（検算で合致すべき金額）
     * @type {number}
     * @memberof ListOperations200ResponseItemsInner
     */
    totalAmount?: number;
    /**
     * 支払集計日
     * @type {Date}
     * @memberof ListOperations200ResponseItemsInner
     */
    settlementDate: Date;
    /**
     * 
     * @type {ListOperations200ResponseItemsInnerPeriod}
     * @memberof ListOperations200ResponseItemsInner
     */
    period: ListOperations200ResponseItemsInnerPeriod;
    /**
     * 承認ステータス
     * @type {number}
     * @memberof ListOperations200ResponseItemsInner
     */
    approvalStatus: ListOperations200ResponseItemsInnerApprovalStatusEnum;
    /**
     * 業務処理ステータス
     * 
     * @type {number}
     * @memberof ListOperations200ResponseItemsInner
     */
    processStatus: ListOperations200ResponseItemsInnerProcessStatusEnum;
}


/**
 * @export
 */
export const ListOperations200ResponseItemsInnerApprovalStatusEnum = {
    PENDING: 0,
    APPROVED: 1
} as const;
export type ListOperations200ResponseItemsInnerApprovalStatusEnum = typeof ListOperations200ResponseItemsInnerApprovalStatusEnum[keyof typeof ListOperations200ResponseItemsInnerApprovalStatusEnum];

/**
 * @export
 */
export const ListOperations200ResponseItemsInnerProcessStatusEnum = {
    COMPLETED_AGGREGATED: 0,
    FAILED: 1,
    COMPLETED_PUBLISHED: 2,
    COMPLETED_DETAIL_PUBLISHED: 3,
    RUNNING: 4
} as const;
export type ListOperations200ResponseItemsInnerProcessStatusEnum = typeof ListOperations200ResponseItemsInnerProcessStatusEnum[keyof typeof ListOperations200ResponseItemsInnerProcessStatusEnum];


/**
 * Check if a given object implements the ListOperations200ResponseItemsInner interface.
 */
export function instanceOfListOperations200ResponseItemsInner(value: object): value is ListOperations200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('serviceName' in value) || value['serviceName'] === undefined) return false;
    if (!('settlementDate' in value) || value['settlementDate'] === undefined) return false;
    if (!('period' in value) || value['period'] === undefined) return false;
    if (!('approvalStatus' in value) || value['approvalStatus'] === undefined) return false;
    if (!('processStatus' in value) || value['processStatus'] === undefined) return false;
    return true;
}

export function ListOperations200ResponseItemsInnerFromJSON(json: any): ListOperations200ResponseItemsInner {
    return ListOperations200ResponseItemsInnerFromJSONTyped(json, false);
}

export function ListOperations200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOperations200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'serviceName': json['service_name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'serviceFee': json['service_fee'] == null ? undefined : json['service_fee'],
        'totalAmount': json['total_amount'] == null ? undefined : json['total_amount'],
        'settlementDate': (new Date(json['settlement_date'])),
        'period': ListOperations200ResponseItemsInnerPeriodFromJSON(json['period']),
        'approvalStatus': json['approval_status'],
        'processStatus': json['process_status'],
    };
}

export function ListOperations200ResponseItemsInnerToJSON(json: any): ListOperations200ResponseItemsInner {
    return ListOperations200ResponseItemsInnerToJSONTyped(json, false);
}

export function ListOperations200ResponseItemsInnerToJSONTyped(value?: ListOperations200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'service_name': value['serviceName'],
        'amount': value['amount'],
        'service_fee': value['serviceFee'],
        'total_amount': value['totalAmount'],
        'settlement_date': ((value['settlementDate']).toISOString().substring(0,10)),
        'period': ListOperations200ResponseItemsInnerPeriodToJSON(value['period']),
        'approval_status': value['approvalStatus'],
        'process_status': value['processStatus'],
    };
}

